export default "__VITE_ASSET__ByoZ6I24__"